export type ItemDetailsItemPayload = any;

export interface ItemDetailsState {
  activeItem: ItemDetailsItemPayload | null;
  activeItemIndex: number | null;
  activeItemDatasource: string | null;
}

export enum ItemDetailsActionTypes {
  ACTIVE_ITEM_CHANGED = 'item-details/active-item-changed',
}

export interface ActionActiveItemChanged {
  type: ItemDetailsActionTypes.ACTIVE_ITEM_CHANGED;
  item: ItemDetailsItemPayload | null;
  index?: number | null;
  datasource?: string | null;
}

export type ItemDetailsAction = ActionActiveItemChanged;
